/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

/* global SENSEI_ENDPOINT */
/* global SENSEI_API_KEY */
/* global ANONYMOUS_USER_SENSEI_ENDPOINT */
/* global ANONYMOUS_USER_SENSEI_API_KEY */

import { auth2 as auth } from "dc-core";
import { downloadStream, uploadStream } from "../AdobeSenseiPredictClient/AdobeSenseiPredictClientUtils";
import { generateTransactionId, getIMSAccessToken } from "../AdobeSenseiPredictClient/GetSenseiAccessParameters";


const fetchCNFTPDFUpdatesCallback = ({ cnpdfZipData, mimeType }) => new Promise((resolve, reject) => {
    const transactionId = generateTransactionId();
    const cnpdfBlob = new Blob([cnpdfZipData], { type: mimeType });
    const isAnonymousUser = !auth.isSignedIn;

    let token;
    let senseiPostEndPoint;
    let senseiGetEndPoint;
    let senseiAPIKey;

    if (isAnonymousUser) {
        senseiPostEndPoint = `${ANONYMOUS_USER_SENSEI_ENDPOINT}/predict`;
        senseiGetEndPoint = `${ANONYMOUS_USER_SENSEI_ENDPOINT}/status`;
        senseiAPIKey = `${ANONYMOUS_USER_SENSEI_API_KEY}`;
    } else {
        token = getIMSAccessToken();
        senseiPostEndPoint = `${SENSEI_ENDPOINT}/${transactionId}`;
        senseiGetEndPoint = `${SENSEI_ENDPOINT}/${transactionId}`;
        senseiAPIKey = `${SENSEI_API_KEY}`;
    }

    uploadStream(
        cnpdfBlob,
        senseiPostEndPoint,
        senseiAPIKey,
        transactionId,
        token,
    )
        .catch(e => {
            reject(e);
        });

    downloadStream(
        senseiGetEndPoint,
        senseiAPIKey,
        transactionId,
        token,
    )
        .then(stream => {
            resolve(stream);
        })
        .catch(e => {
            reject(e);
        });
});

export default fetchCNFTPDFUpdatesCallback;
